import { UserImageWithFallback } from "@/react/components/shared/uikit/UserImageWithFallback";

interface UserAvatarProps {
  name: string;
  src?: string;
}

export const UserAvatar = ({ src, name }: UserAvatarProps) => (
  <div className="flex size-[20px] shrink-0 justify-center overflow-hidden rounded-full">
    <UserImageWithFallback src={src} size="5" name={name} isFullRounded />
  </div>
);
